module.exports = __webpack_public_path__ + "img/88.8df7f44b.jpg";